module.exports = __webpack_public_path__ + "img/gift.58ff3756.png";